var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3199 5.86651L7.99992 8.99984L7.99992 12.6665C7.99992 13.2198 7.55325 13.6665 6.99992 13.6665C6.44658 13.6665 5.99992 13.2198 5.99992 12.6665L5.99992 8.99984L0.679919 5.8665C0.466586 5.7465 0.333252 5.51317 0.333252 5.2665C0.333252 4.79984 0.779919 4.46651 1.22659 4.59317L5.99992 5.99317L5.99992 2.33317L4.49325 1.43317C4.39325 1.37317 4.33325 1.25984 4.33325 1.1465L4.33325 0.813171L4.33325 0.759837C4.33325 0.539838 4.53992 0.379838 4.74659 0.433171L6.69325 0.919837L6.99992 0.999838L7.25325 0.939838L7.53325 0.866504L8.79992 0.546504L9.24659 0.433172C9.45992 0.379838 9.65992 0.539838 9.65992 0.759838L9.65992 1.00651L9.65992 1.1465C9.65992 1.2665 9.59992 1.37317 9.49992 1.43317L7.99992 2.33317L7.99992 5.99984L12.7733 4.59984C13.2199 4.4665 13.6666 4.79984 13.6666 5.2665C13.6666 5.51317 13.5333 5.7465 13.3199 5.86651Z",
    fill: "#CF9D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightOn);
export default __webpack_public_path__ + "static/media/flight-on.c815494dc946553d44c7dc9cf864f01f.svg";
export { ForwardRef as ReactComponent };